<template>
  <div class="atelier-analyse-tab p-2">
    <LoadingSpinner v-if="loading" />

    <div v-else-if="error" class="alert alert-danger mb-0" role="alert">
      {{ error }}
    </div>

    <div v-else>
      <!-- <div class="card mb-3">
        <div class="card-body">
          <h5 class="fw-bold mb-3">{{ $t('lang.analysis_workshop.title') }}</h5>
          <p class="mb-1 text-muted">{{ $t('lang.analysis_workshop.user_id_label') }}</p>
          <p v-if="userId != null" class="fs-5 mb-0 fw-semibold">{{ userId }}</p>
          <p v-else class="text-muted mb-0">{{ $t('lang.analysis_workshop.user_id_not_found') }}</p>
        </div>
      </div> -->

      <BdrTask
        v-if="userId != null && clientId"
        :clientId="clientId"
        :user_bdr_id="userId"
        :withTaskType="['coldphoning']"
        :withCheckbox="true"
        :downloading="downloadingExport"
        @download-selected-tasks="downloadSelectedTasks"
        @analyse-client-calls="analyseClientCalls"
      />

      <AnalyseCalls
        v-if="clientId && analyseCallIds.length"
        class="mt-3"
        :clientId="clientId"
        :callIds="analyseCallIds"
      />
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import BdrTask from '@/components/BDR/BdrTasks.vue'
import AnalyseCalls from '@/components/BDR/AnalyseCalls.vue'
import { bookersService, adminService } from '@/_services'

export default {
  name: 'AtelierAnalyseClient',

  components: {
    LoadingSpinner,
    BdrTask,
    AnalyseCalls,
  },

  props: {
    clientId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      loading: true,
      userId: null,
      error: null,
      downloadingExport: false,
      analyseCallIds: [],
    }
  },

  watch: {
    clientId: {
      immediate: true,
      handler() {
        this.loadBookerUserId()
      },
    },
  },

  methods: {
    analyseClientCalls(data) {
      const callIds = (data || [])
        .map((id) => parseInt(id, 10))
        .filter((id) => Number.isInteger(id) && id > 0)

      if (!callIds.length) {
        this.$swal({
          icon: 'warning',
          title: this.$t('lang.atention'),
          text: this.$t('lang.analysis_workshop.no_calls_selected'),
        })
        return
      }

      this.analyseCallIds = callIds
    },

    downloadSelectedTasks(selectedTaskIds) {
      if (!this.clientId) return
      const callIds = (selectedTaskIds || [])
        .map((id) => parseInt(id, 10))
        .filter((id) => Number.isInteger(id) && id > 0)

      if (!callIds.length) {
        this.$swal({
          icon: 'warning',
          title: this.$t('lang.atention'),
          text: this.$t('lang.analysis_workshop.no_calls_selected'),
        })
        return
      }

      if (this.downloadingExport) return
      this.downloadingExport = true

      adminService
        .exportClientAnalyse(this.clientId, callIds)
        .then(({ blob, filename }) => {
          const blobUrl = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = blobUrl
          a.download = filename
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          setTimeout(() => URL.revokeObjectURL(blobUrl), 1000)
        })
        .catch((err) => {
          const message =
            (err && (err.error || err.message)) ||
            this.$t('lang.analysis_workshop.export_error')
          this.$swal({
            icon: 'error',
            title: this.$t('lang.atention'),
            text: message,
          })
        })
        .finally(() => {
          this.downloadingExport = false
        })
    },
    loadBookerUserId() {
      bookersService
        .getAiAgentBookerUserId(this.clientId)
        .then((res) => {
          var userId = res && res.result && res.result.user_id
          this.userId = userId != null ? userId : null
        })
        .catch(() => {
          this.error = this.$t('lang.analysis_workshop.load_error')
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
